// M12.1 - ReviMotricityGamesAPI (admin)
//
// Cliente para el catalogo de juegos VR de motricidad. Lo consume la
// pagina admin /admin/revi?tab=motricity-games. Sustituye a la
// whitelist ALLOWED_GAME_KEYS hardcodeada que existia en M12.

import { ENV } from "../Utils";

const BASE = `${ENV.BASE_API}/admin/revi/motricity/games`;

function headers(token, extra = {}) {
  return { Authorization: `Bearer ${token}`, ...extra };
}

async function asJson(response) {
  let body = null;
  try {
    body = await response.json();
  } catch (e) {
    body = null;
  }
  if (!response.ok) {
    const err = new Error((body && body.message) || `HTTP ${response.status}`);
    err.status = response.status;
    err.body = body;
    throw err;
  }
  return body;
}

export class ReviMotricityGamesAPI {
  async list(token) {
    const r = await fetch(BASE, { headers: headers(token) });
    return asJson(r);
  }

  async create(token, payload) {
    const r = await fetch(BASE, {
      method: "POST",
      headers: headers(token, { "Content-Type": "application/json" }),
      body: JSON.stringify(payload),
    });
    return asJson(r);
  }

  async update(token, id, patch) {
    const r = await fetch(`${BASE}/${id}`, {
      method: "PATCH",
      headers: headers(token, { "Content-Type": "application/json" }),
      body: JSON.stringify(patch),
    });
    return asJson(r);
  }

  // Soft delete: el server pone enabled=false y preserva el historico.
  async disable(token, id) {
    const r = await fetch(`${BASE}/${id}`, {
      method: "DELETE",
      headers: headers(token),
    });
    return asJson(r);
  }
}
